export default {"src":"/_next/static/media/white_star.d34bdc5e.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};